var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"navigation-button"},[_c('span',{on:{"click":function($event){return _vm.setUiState(_vm.uiState)}}},[_vm._v(" "+_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }